// import "@babel/polyfill";
// import Vue from "vue";
// import Vuex from "vuex";
import { createStore } from "vuex";
import Cookie from "../save/Cookie.js";
import util from "../views/util/js/util.js";
import project from "./project.js";
import join from "./join.js";

const data = {
  state: {
    user_id: "",
    user_name: "",
    user_tel: "",
    user_mail: "",
    is_superuser: 0,
    timezone: "",
    anchor_date: new Date().toISOString().slice(0, 10),
    setting: {},
    cookie: {},
    color_mode: "light",
    modalType: "",
    modalProps: {},
    spinner: {},
    view_mode: "list",
    project: project.state,
    join: join.state,
  },
  mutations: {
    setUserId(state, payload) {
      state.user_id = payload;
    },
    setUserName(state, payload) {
      state.user_name = payload;
    },
    setUserTel(state, payload) {
      state.user_tel = payload;
    },
    setUserMail(state, payload) {
      state.user_mail = payload;
    },
    setIsSuperuser(state, payload) {
      state.is_superuser = payload;
    },
    setTimezone(state, payload) {
      state.timezone = payload;
      Cookie.set("timezone", payload);
    },
    setSetting(state, payload) {
      state.setting = payload;
    },
    setColorMode(state, payload) {
      state.color_mode = payload || "light";
      Cookie.set("theme", payload);
    },
    setModalType(state, payload) {
      state.modalType = payload;
    },
    setModalProps(state, payload) {
      state.modalProps = payload;
    },
    setCookie(state, payload) {
      state.cookie = payload;
      Cookie.setInit(payload);
      Cookie.clearKey();
    },
    addSpinner(state, payload) {
      state.spinner[payload.key] = payload.value;
    },
    setViewMode(state, payload) {
      state.view_mode = payload || "list";
      if (payload === "card") {
        Cookie.setInit(payload);
      } else if (payload === "list") {
        Cookie.setInit(payload);
      }
    },
  },
  getters: {},
  actions: {},
};

data.mutations = Object.assign(data.mutations, util.sBind("project", project));
data.getters = Object.assign(data.getters, util.sgBind("project", project));
data.actions = Object.assign(data.actions, util.saBind("project", project));

data.mutations = Object.assign(data.mutations, util.sBind("join", join));
data.getters = Object.assign(data.getters, util.sgBind("join", join));
data.actions = Object.assign(data.actions, util.saBind("join", join));

// Vue.use(Vuex);

const self = createStore(data);
// new Vuex.Store(data);

export default self;
